import { getType } from 'typesafe-actions';

import { Step, StepsModalState, UIState, ModalState } from '../../util/types';
import * as actions from '../actions';
import { RootAction } from '../reducers';
import LanguageService from '../../i18n';
import { LocalStorage } from '../../services/local_storage';
// import { BigNumber } from '@0x/utils';

const LocalStorages = new LocalStorage();
// const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

const initialStepsModalState: StepsModalState = {
    doneSteps: [],
    currentStep: null,
    pendingSteps: [],
};
const modalState: ModalState = {
    title: '',
    body: '',
}
const initialUIState: UIState = {
    notifications: [],
    hasUnreadNotifications: false,
    stepsModal: initialStepsModalState,
    orderPriceSelected: null,
    theme: LocalStorages.getTheme() || 'LIGHT_THEME',
    language: LanguageService.getLanguage() || 'en',
    tradeHistories: [],
    userHistories: [],
    orderSelected: [],
    modal: modalState,
};

export function stepsModal(state: StepsModalState = initialStepsModalState, action: RootAction): StepsModalState {
    switch (action.type) {
        case getType(actions.locationChange):
            toTop();
            return { ...state };
        case getType(actions.setStepsModalDoneSteps):
            return { ...state, doneSteps: action.payload };
        case getType(actions.setStepsModalPendingSteps):
            return { ...state, pendingSteps: action.payload };
        case getType(actions.setStepsModalCurrentStep):
            return { ...state, currentStep: action.payload };
        case getType(actions.stepsModalAdvanceStep):
            const { doneSteps, currentStep, pendingSteps } = state;
            // This first condition may happen in async scenarios
            if (currentStep === null && pendingSteps.length === 0) {
                return state;
            } else if (pendingSteps.length === 0 && currentStep !== null) {
                return {
                    ...state,
                    doneSteps: doneSteps.concat([currentStep as Step]),
                    currentStep: null,
                };
            } else {
                return {
                    ...state,
                    pendingSteps: pendingSteps.slice(1),
                    doneSteps: doneSteps.concat([currentStep as Step]),
                    currentStep: pendingSteps[0] as Step,
                };
            }
        case getType(actions.stepsModalReset):
            return initialStepsModalState;
        default:
            return state;
    }
}

export function ui(state: UIState = initialUIState, action: RootAction): UIState {
    switch (action.type) {
        case getType(actions.setHasUnreadNotifications):
            return { ...state, hasUnreadNotifications: action.payload };
        case getType(actions.setOrderPriceSelected):
            return { ...state, orderPriceSelected: action.payload };
        case getType(actions.setOrderSelected):
            return { ...state, orderSelected: action.payload };
        case getType(actions.setNotifications):
            return { ...state, notifications: action.payload };
        case getType(actions.setThemeUI):
            return { ...state, theme: action.payload };
        case getType(actions.setLanguage):
            return { ...state, language: action.payload };
        case getType(actions.getUserHistory):
            return { ...state, userHistories: action.payload };
        case getType(actions.getTradeHistory):
            return { ...state, tradeHistories: action.payload };
        case getType(actions.addTradeHistory):
            let { tradeHistories } = state;
            let records = tradeHistories.concat(action.payload);
            return { ...state, tradeHistories: records };
        case getType(actions.addNotifications): {
            const newNotifications = action.payload.filter(notification => {
                const doesAlreadyExist = state.notifications
                    .filter(n => n.kind === notification.kind)
                    .some(n => n.id === notification.id);

                return !doesAlreadyExist;
            });

            if (newNotifications.length) {
                return {
                    ...state,
                    notifications: [...newNotifications, ...state.notifications],
                    hasUnreadNotifications: true,
                };
            } else {
                return state;
            }
        }
        case getType(actions.setModal):
            return { ...state, modal: action.payload };
        case getType(actions.closeModal):
            return { ...state, modal: modalState };
        default:
            return {
                ...state,
                stepsModal: stepsModal(state.stepsModal, action),
            };
    }
}

const toTop = () => {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
}
